import { baseSiteEndPoint, buildHeaders, urlFilters, getSellerID } from "./common";
import { authorizedFetch } from "./login";

export const apiGetTotalBalance = async () => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/admin/accounts/total-balance`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetVirtualAccounts = async (filters) => {
  try {
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/uniconta/admin/accounts/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetVirtualAccountDetails = async (accountId) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/admin/accounts/${accountId}/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetVirtualAccountEntries = async (accountId, filters) => {
  try {
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/uniconta/seller/${getSellerID()}/virtualaccounts/${accountId}/entries/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetManagedVirtualAccountEntries = async (virtualAccountId, filters) => {
  try {
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/uniconta/seller/${virtualAccountId}/virtualaccounts/${virtualAccountId}/entries/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetManagedAccounts = async (filters) => {
  try {
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/uniconta/admin/managed-accounts/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetManagedAccount = async (id) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/admin/managed-accounts/${id}/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiUpdateManagedAccount = async (id, data) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/admin/managed-accounts/${id}/`,
      {
        method: "PATCH",
        headers: buildHeaders(),
        body: JSON.stringify(data),
      }
    );
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};

export const apiGetManagedAccountMetrics = async (id) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/admin/managed-accounts/${id}/metrics/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetManagedAccountTotalBalance = async () => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/admin/managed-accounts/total-balance/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetManagedAccountVirtualAccountDetail = async (managedAccountId, virtualAccountId) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/admin/managed-accounts/${managedAccountId}/virtual-accounts/${virtualAccountId}/`,
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiGetManagedAccountVirtualAccounts = async (managedAccountId, filters) => {
  try {
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/uniconta/admin/managed-accounts/${managedAccountId}/virtual-accounts/`, filters),
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiExportManagedAccountReport = async (managedAccountId, statuses) => {
  try {
    const response = await authorizedFetch(
      `${baseSiteEndPoint}/uniconta/admin/managed-accounts/${managedAccountId}/export-report/`,
      {
        method: "POST",
        headers: buildHeaders(),
        body: JSON.stringify({ statuses }),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const blob = await response.blob();
    return { blob };
  } catch (error) {
    throw error;
  }
};
